import { useState, useRef, useEffect, useCallback } from 'react';
import { useDebounce } from 'use-debounce';
import { updateDayNotesService } from '../../../../../services/scheduling';
import { isMobile } from 'react-device-detect';
import cx from 'classnames';
import { usePermission } from '../../../../../container/permissionContext';

const SchedulingDayNotes = ({ day, setPeriodData, hasRedBorder, forceReadOnly = false }) => {
  const ref = useRef(null);
  const { hasPermissionByCodeName, isSuperAdmin } = usePermission();
  const hasWritePermission = hasPermissionByCodeName('scheduling_management');

  const [value, setValue] = useState(day.notes);
  const [hasChanged, setHasChanged] = useState(false);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.minHeight = '0px'; // reset first
    el.style.minHeight = el.scrollHeight + 'px'; // then grow to content
  };

  const [debouncedValue] = useDebounce(value, 500);

  useEffect(() => {
    resize();
  }, [value]);

  useEffect(() => {
    setValue(day.notes);
  }, [day.notes]);

  useEffect(() => {
    resize();
    const id = setTimeout(resize, 0);
    return () => clearTimeout(id);
  }, []);

  const updateNotesValue = useCallback(
    async (value) => {
      try {
        const response = await updateDayNotesService(day.id, { notes: value });
        if (response.data) {
          setPeriodData((state) => {
            return {
              ...state,
              days: state.days.map((periodDay) => {
                if (periodDay.id === day.id) {
                  return {
                    ...periodDay,
                    notes: value,
                  };
                }
                return periodDay;
              }),
            };
          });
        }
      } catch (e) {
        console.error('Failed to update notes:', e);
      }
    },
    [day.id],
  );

  useEffect(() => {
    if (debouncedValue !== undefined && hasChanged) {
      updateNotesValue(debouncedValue);
    }
  }, [debouncedValue, updateNotesValue]);

  return (
    <td colSpan={3} className={cx('notes-col', { 'has-red-border': hasRedBorder })}>
      <textarea
        ref={ref}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          setHasChanged(true);
        }}
        placeholder=""
        spellCheck="false"
        rows={1}
        readOnly={isMobile || !hasWritePermission || forceReadOnly}
      />
    </td>
  );
};

export default SchedulingDayNotes;
